import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'help',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: lazy(() => import('@/page/help/HelpPage')),
      },
      {
        path: 'mouse-keyboard',
        Component: lazy(() => import('@/page/help/MouseKeyboardPage')),
      },
      {
        path: 'schema',
        Component: lazy(() => import('@/page/help/SchemaPage')),
      },
    ],
  },
];

export default routes;
